/** What the create dialog's setup step (type, and visibility where workspaces are shown) has to offer. */
type SetupChoices = {
  hasVisibilityChoice: boolean;
  resourceTypeCount: number;
};

export const resourceCreateDialogLogic = {
  /** The dialog opens on the setup step when something there is still to choose. */
  opensOnSetup(input: SetupChoices & { typeGiven: boolean }): boolean {
    return (
      input.hasVisibilityChoice ||
      (input.resourceTypeCount > 1 && !input.typeGiven)
    );
  },
  /** The form leads back to the setup step when there is anything to change there. */
  canGoBack(input: SetupChoices): boolean {
    return input.hasVisibilityChoice || input.resourceTypeCount > 1;
  }
};
